"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appUpdateCommonConfig = appUpdateCommonConfig;
exports.appUpdateTenant = appUpdateTenant;
exports.editLicenseAndPrivacy = editLicenseAndPrivacy;
exports.queryAppDetail = queryAppDetail;
exports.queryLicenseAndPrivacy = queryLicenseAndPrivacy;
exports.queryWhiteList = queryWhiteList;
exports.setWhiteList = setWhiteList;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryAppDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/queryAppDetail',
    method: 'get',
    params: params
  });
}
function appUpdateCommonConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/appUpdateCommonConfig',
    method: 'post',
    data: data
  });
}
function appUpdateTenant(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/appUpdateTenant',
    method: 'post',
    data: data
  });
}
function queryLicenseAndPrivacy(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/queryLicenseAndPrivacy',
    method: 'get',
    params: params
  });
}
function editLicenseAndPrivacy(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/editLicenseAndPrivacy',
    method: 'post',
    data: data
  });
}
function queryWhiteList(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/queryWhiteList',
    method: 'get',
    params: params
  });
}
function setWhiteList(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/setWhiteList',
    method: 'post',
    data: data
  });
}